// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"098abc30","73":"0c55483f","308":"61c80237","366":"1e23acd5","466":"c2888b18","877":"81d9a39c"}[chunkId] + ".chunk.js";
};